export function _size(array: unknown[] | undefined): number {
    return !!array ? array.length : 0;
}
